module.exports = __webpack_public_path__ + "static/media/github.00f85ba2.png";